import { Box, Grid, Paper, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CustomerGroupListItem } from "../../lib/models/CustomerGroupListItem";
import { Dispatch, StoreState } from "../../store";
import AddCustomerGroup from "./CustomerGroup/AddCustomerGroup";
import CustomerGroup from "./CustomerGroup/CustomerGroup";
import CustomerGroupSkeleton from "./CustomerGroup/CustomerGroupSkeleton";

export default function CustomerGroupList() {
  const classes = useStyles();
  const dispatch = useDispatch<Dispatch>();

  const [showSkeleton, setShowSkeleton] = useState(false);
  const customerGroupList = useSelector(
    (state: StoreState) => state.customerGroupList
  );
  const activeCustomerGroup = useSelector(
    (state: StoreState) => state.activeCustomerGroup
  );

  useEffect(() => {
    dispatch.customerGroupList.fetchCustomerGroupList(null);
  }, [dispatch]);

  const customerGroups = _.sortBy(
    customerGroupList.payload,
    (item) => item.createdAt
  );

  useEffect(() => setShowSkeleton(false), [customerGroups]);

  const missingGroupsDetected = () =>
    customerGroups.some((group: CustomerGroupListItem) => group.adaptionError);

  const groupListAlert = () => {
    const namesOfMissingGroups = customerGroups
      .filter((group: CustomerGroupListItem) => group.adaptionError)
      .map((group: CustomerGroupListItem) => group.groupName)
      .join(", ");
    return (
      <Alert severity="error">
        Folgende Kundengruppe(n) konnte(n) nicht geladen werden:
        <span style={{ fontWeight: 600 }}>{` ${namesOfMissingGroups}. `}</span>
        Bitte wenden Sie sich an den Administrator.
      </Alert>
    );
  };

  return (
    <Paper className={classes.paper}>
      <Typography variant="h6" gutterBottom>
        Gespeicherte Kundengruppen
      </Typography>

      <Grid container spacing={4}>
        {customerGroups.length > 0 &&
          customerGroups.map(
            (item: CustomerGroupListItem, index: number) =>
              !item.adaptionError && (
                <CustomerGroup
                  key={index}
                  customerGroup={item}
                  selected={activeCustomerGroup?.uuid === item.uuid}
                />
              )
          )}
        {showSkeleton && <CustomerGroupSkeleton />}
        <AddCustomerGroup onAdd={() => setShowSkeleton(true)} />
      </Grid>
      <Box marginTop={2}>{missingGroupsDetected() && groupListAlert()}</Box>
    </Paper>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
    },
  })
);



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/CustomerGroupList.tsx